module.exports = __webpack_public_path__ + "static/media/Problems-Watch-7yr-olds-09-l.7b250bad.pdf";